import { Grid, Typography } from '@material-ui/core';
import { AccountBalance, CreditCard } from '@material-ui/icons';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import {
  PaymentCategory,
  PaymentProfile,
} from '../../../__generated__/pge-types';
import Modal from '../../modal';
import TextLink from '../../text-link';
import PaymentCategoryIcon from '../payment-profile-icon/PaymentCategoryIcon';
import PaymentusIFrame from '../paymentus-iframe';
import { EditProps, ProfileChangeHandler } from '../types';

type Props = {
  open: boolean;
  editProps: EditProps;
};

const EditPaymentProfile = ({ open, editProps }: Props) => {
  const { t } = useTranslation();
  const { onClose, onNew, onChange, iframeProps } = editProps;

  const PM_CATEGORY_MAP = new Map<any, any>();

  PM_CATEGORY_MAP.set(PaymentCategory.Dd, {
    label: t('BANK_ACCOUNT'),
    icon: <AccountBalance color={'primary'} />,
  });

  PM_CATEGORY_MAP.set(PaymentCategory.Cc, {
    label: t('CREDIT_CARD'),
    icon: <CreditCard color={'primary'} />,
  });

  PM_CATEGORY_MAP.set(PaymentCategory.Dc, {
    label: t('DEBIT_CARD'),
    icon: <CreditCard color={'primary'} />,
  });

  PM_CATEGORY_MAP.set(PaymentCategory.PaypalAccount, {
    label: t('PAYPAL_ACCOUNT'),
    icon: <PaymentCategoryIcon type={PaymentCategory.PaypalAccount} />,
  });

  PM_CATEGORY_MAP.set(PaymentCategory.PaypalCredit, {
    label: t('PAYPAL_CREDIT'),
    icon: <PaymentCategoryIcon type={PaymentCategory.PaypalCredit} />,
  });

  PM_CATEGORY_MAP.set(PaymentCategory.AmazonPay, {
    label: t('AMAZON_PAY'),
    icon: <PaymentCategoryIcon type={PaymentCategory.AmazonPay} />,
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      children={
        <Grid container spacing={2} style={{ maxWidth: '480px' }}>
          {!!iframeProps?.token && (
            <Grid container item direction="row" justify={'flex-start'}>
              <Typography variant={'h2'}>{t('EDIT_PAYMENT_METHOD')}</Typography>
            </Grid>
          )}

          {iframeProps?.pmCategory && (
            <Grid container item direction="row" spacing={2}>
              <Grid item>
                {PM_CATEGORY_MAP.get(iframeProps?.pmCategory).icon}
              </Grid>
              <Grid item>
                <Typography variant="body1" color={'primary'}>
                  {PM_CATEGORY_MAP.get(iframeProps?.pmCategory).label}
                </Typography>
              </Grid>
            </Grid>
          )}
          <Grid container item>
            <PaymentusIFrame
              {...{
                onChange: profile => onChange && onChange(profile),
                onNew: (profile: PaymentProfile) => onNew && onNew(profile),
                buttonLabelText: t('SAVE_CHANGES'),
                iframeProps: {
                  ...iframeProps,
                },
              }}
            ></PaymentusIFrame>
          </Grid>
          {!!iframeProps?.token && (
            <Grid container item direction="row" justify={'flex-start'}>
              <TextLink
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClose && onClose();
                }}
                style={{ textDecoration: 'none' }}
              >
                {t('CANCEL')}
              </TextLink>
            </Grid>
          )}
        </Grid>
      }
    ></Modal>
  );
};

export default EditPaymentProfile;
